module.exports = __webpack_public_path__ + "img/mobbing-bei-kindern.23f55c52.jpg";